<template>
  <a-config-provider :locale="language === 'English' ? enUS : zhCN">
  <div>
    <a-layout-content style="padding: 0 20px">
      <div class="main">
        <a-table bordered :emptyText="'暂无数据'" :columns="columns" :data-source="dataSource" :pagination="false"
          :loading="loading" size="small">
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.dataIndex === 'online'">
              <span>
                <div class="greenpoint" v-if="text == '1'"></div>
                <div class="redpoint" v-else></div>
                <span v-if="text == '1'">{{ getLanguage('在线') }}</span>
                <span v-else>{{ getLanguage('断线') }}</span>
              </span>
            </template>
            <template v-if="column.dataIndex === 'date'">
              {{ transformLocalDate(text) }}
            </template>
            <template v-if="column.dataIndex === 'act'">
              <a-popconfirm :title="getLanguage('确定删除此条数据')"  @confirm="deleteThis(record)">
                <a-button type="primary" danger><delete-outlined />{{ getLanguage('删除') }}</a-button>
              </a-popconfirm>
            </template>
          </template>
        </a-table>
      </div>
    </a-layout-content>
  </div>
  </a-config-provider>
</template>
  
<script lang="ts" setup>
import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "vue-router";
import { computed, defineComponent } from "vue";
import { ref, reactive, toRaw } from "vue";
import type { TableProps } from "ant-design-vue";
import { message } from "ant-design-vue";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getLanguage } from "@/common/translate";
import { transformBeiJingDate, transformLocalDate } from "../../common/tools";

const loading = ref(false);
/**操作日志记录 */
import { operateLogs } from "@/common/logs";
operateLogs('Access sensor management');
/**操作日志记录 */
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
}
getLang();
const modalState = reactive({
  visible: false,
  title: getLanguage("配置"),
  confirmLoading: false,
});
const formState = ref({
  factoryId: '',
  keyword: "",
  enable: "-1",
  skip: 1,
  take: 10,
});

// 新增
const add = () => {
  modalState.title = getLanguage("新增");
  modalForm.value = {
    enable: true,
    factoryId: "",
    id: 0,
    nickName: "",
    userName: "",
    password: ''
  };
  modalState.visible = true;
};

const pagination = computed(() => ({
  total: 0,
  current: formState.value.skip,
  pageSize: formState.value.take,
}));
const deleteThis = (val: any) => {
  const config = {
    params: { key: val.key },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.delete("/api/external/service/status", config).then((res) => {
    if (res) {
      message.success(getLanguage("操作成功"));
      search();
    } else {
    }
  });
};
let dataSource = ref([]);
const columns = [
  {
    title: getLanguage("服务名称"),
    dataIndex: "name",
    align: "center"
  },
  {
    title: getLanguage("服务描述"),
    dataIndex: "remark",
    align: "center"
  },
  {
    title: getLanguage("服务器ip"),
    dataIndex: "ip",
    align: "center"
  },
  {
    title: getLanguage("服务器端口号"),
    dataIndex: "port",
    align: "center"
  },
  {
    title: getLanguage("最后在线时间"),
    dataIndex: "date",
    align: "center"
  },
  {
    title: getLanguage("当前是否在线"),
    dataIndex: "online",
    align: "center"
  },
  {
    title: getLanguage("操作"),
    dataIndex: "act",
    align: "center"
  }
];

let modalForm = ref<any>({
  enable: true,
  factoryId: "",
  id: 0,
  nickName: "",
  userName: "",
});
const formStateRef = ref<any>();
const roleSetting = async (val: any) => {
  modalState.title = "配置";
  const config = {
    params: { id: val.config_id },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result2 = await request.get("/api/dt/das/info", config);
  modalForm.value = reactive(JSON.parse(JSON.stringify(result2.data)));
  modalState.visible = true;
  setTimeout(() => {
    formStateRef.value.clearValidate();
  }, 500);
};
const clearValidate = (name: any) => {
  formStateRef.value.clearValidate(name);
};

// 查询
const search = () => {
  const config = {
    params: formState.value,
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/external/service/status", config).then((res) => {
    if (res) {
      dataSource.value = res.data;
    }
  });
};

search();
const roleList = ref<any>();
// 查询
const getRole = () => {
  const config = {
    params: { keyword: "" },
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/roles", config).then((res: any) => {
    if (res) {
      roleList.value = res.data.list;
    }
  });
};
getRole();
let factoryList = ref<any>()
const loadFactory = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {

      // 2级工厂
      var list = res.data.map((t: any) => ({
        key: t._id,
        title: t.factoryName,
        value: t._id,
        label: t.factoryName,
        parentId: t.parentId,
        id: t._id,
        type: "factory"
      }));
      // let factory = [];
      // for (var i = 0; i < list.length; i++) {
      //   var element = list[i];
      //   if (!element.parentId) {
      //     element.children = list.filter((t: any) => t.parentId == element.id);
      //     factory.push(element);
      //   }
      // }
      factoryList.value = list;
    }
  });
};
loadFactory()
</script>
<style  scoped>
.main {
  margin-top: 30px;
}

.greenpoint {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: green;
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 5px;
}

.redpoint {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: red;
  display: inline-block;
  position: relative;
  top: 2px;
  margin-right: 5px;
}
</style>